import axios from "axios";
import React, { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import {baseUrl, baseimgUrl, userLocation, ipAddress, userName} from '../PatUniv.js'
  function PatDrugPres(props) {
      const {appt_id} = useParams();
      const pat_id = localStorage.getItem('pat_id');
      const loc = 1;
      const [opcaseData, setOpcaseData] = useState([]);
      const [viewPharmData, setViewPharmData] = useState([]);
      const [hospData, setHospData] = useState([]);
      useEffect(() => {
        Promise.all([
          axios.get(baseUrl + 'pat-op-case/' + pat_id + '/' + appt_id + '/'),
          axios.get(baseUrl + 'pat-view-hospital/' + loc + '/'),
        ])
          .then(function (responses) {
            const opcaseResponse = responses[0];
            const hospitalResponse = responses[1];

            setOpcaseData(opcaseResponse.data);
            setHospData(hospitalResponse.data);
          })
          .catch(function (error) {
            console.log(error);
          });
      }, [appt_id, userLocation]);

useEffect(() => {
  if (Array.isArray(opcaseData)) {
    const dd = opcaseData.map(row => row.drug_id);

    if (dd !== null) {
      function fetchPharmData1() {
        const drugIds = opcaseData.map(row => row.drug_id?.split(',').map(item => item.trim()));
        drugIds.forEach(drugId => {
          try {
            drugId.forEach(id => {
              axios.get(baseUrl + 'pat-update-indent-use/' + id + '/')
                .then(function (response) {
                  const data = Object.assign({}, response.data);
                  setViewPharmData(prevData => [...prevData, data]);
                })
                .catch(function (error) {
                  console.log(error);
                });
            });
          } catch (error) {
            console.log(error);
          }
        });
      }

      fetchPharmData1();
    }
  }
}, [opcaseData]);

     const handlePrint = () => {
        const printContents = document.getElementById('invoice-print').innerHTML;
        const originalContents = document.body.innerHTML;
        document.body.innerHTML = printContents;
        window.print();
        setTimeout(() => {
            window.location.reload();
        }, 1000);
        document.body.innerHTML = originalContents;
     };

      return (
        <section>
          <div >
            {opcaseData.map((row, index) =>
              <div id="invoice-print">
                <table rules="rows" cellpadding="3" className="text-justify mt-5" width="100%" >
                <thead>
                  <tr>
                    {hospData.map((hospital) => (
                      <React.Fragment key={hospital.id}>
                        <td align="right" colSpan="2" style={{borderBottom: '1px solid black', borderTop: '1px solid black',
                          padding: '4px', borderRadius: '25px', color: '#000'}}>
                          <p align="center">
                         <img
  src={hospital.logo}
  alt="Hospital Logo"
  style={{width:"60px", height:"60px", objectFit:"contain"}}
/>
<strong>{hospital.hospital}</strong><br />
                            Address&nbsp;: &nbsp;{hospital.address}&nbsp;&nbsp;&nbsp;-&nbsp;
                            <br />Phone : {hospital.mobile} &nbsp; Email : {hospital.email} &nbsp; <br />
                            Web : {hospital.website}
                          </p>
                        </td>
                      </React.Fragment>
                    ))}
                  </tr>
                </thead>
                   <tr><th className="mx-0 ps-5" rowSpan="10">
                        <font>Name : {row.appt.pat.patient} </font><br></br>
                        <font>PID : {row.appt.pat.pat_id}</font><br></br>
                   </th></tr>
                   <tr><th className="mx-5 ps-5">
                        <font>Date :&nbsp;{row.add_date}</font><br></br>
                        <font>Consultant : Dr.{row.appt.cons.consultant}</font>
                   </th></tr>
                </table>
                <div className="table-responsive">

           <table className="erp-table-modern">
            <thead>
            <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
              <th>Drug ID</th>
              <th>Drug Name</th>
              <th>Dose</th>
              <th>Freq</th>
              <th>Remarks</th>
            </tr>
          </thead>
          <tbody>
            {Array.isArray(opcaseData) && opcaseData.map((row) => (
              <tr key={row.id}>
                <td>{row.drug_id?.split(',').map((value, index) => <span key={index}>{value}<br /></span>)}</td>
                <td>
                  {viewPharmData?.length > 0 && row.drug_id?.split(',').map((test, index) => {
                    const pharmData = viewPharmData.find((data) => data.id == test);
                    return (
                      <span key={index}>
                        {pharmData?.product.product}
                        <br />
                      </span>
                    );
                  })}
                </td>
                <td>{row.dose?.split(',').map((value, index) => <span key={index}>{value}<br /></span>)}</td>
                <td>{row.freq?.split(',').map((value, index) => <span key={index}>{value}<br /></span>)}</td>
                <td>{row.remarks?.split(',').map((value, index) => <span key={index}>{value}<br /></span>)}</td>
              </tr>
            ))}
          </tbody>
          </table>
            </div>
          </div>
          )}
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} className="mt-5">
          <button style={{ padding: '5px 20px', borderRadius: '10px', backgroundColor: '#007bff', color: '#fff' }}
          onClick={handlePrint}
          >
           Print
          </button>
        </div>
      </div>
    </section>
  );

  }
export default PatDrugPres;